<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in editableTabs" :key="index" :label="item.label" :name="item.id">
        <component :is="item.content" :ref="item.refs"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import individualization from "@/views/userMpp/individualization.vue";
import notice from "@/views/userMpp/notice.vue";
import configure from "@/views/userMpp/configure.vue";
import IPsettings from "@/views/userMpp/IPsettings.vue";
import wechatChange from "@/views/userMpp/wechatChange.vue";
export default {

  data() {
    return {
      editableTabs:[
        { label:"个性化",id:"first",content:individualization,refs:"individualizationRef" },
        { label:"通知",id:"second",content:notice,refs:"noticeRef" },
        { label:"公众号模板配置",id:"third",content:configure ,refs:"configureRef"},
        { label:"白名单配置" , id:"fourth" , content:IPsettings ,refs:"IPsettingsRef"},
        { label:"接入微信【企业付款到零钱】" , id:"fifth" , content:wechatChange},
      ],
      activeName: "first",
    };
  },
  components: {
    individualization, 
    notice,
    configure,
    IPsettings,
    wechatChange
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "first") {
        this.$refs.individualizationRef[0].initData();
      }else if(tab.name == "second"){
        this.$refs.noticeRef[0].initData()
      }else if(tab.name == "third"){
        this.$refs.configureRef[0].initData()
      }else if(tab.name == "fourth"){
        this.$refs.IPsettingsRef[0].clearCheck();
        this.$refs.IPsettingsRef[0].initData();
      }else if(tab.name == "fifth"){
        // this.$refs.IPsettingsRef[0].initData()
      }
    },
  },
  created() {

  },
  mounted() {

  },
};
</script>
<style scoped lang="less">

</style>  